import { useContext } from 'react'
import FeatureFlagsContext from '@/components/feature-flags-provider/feature.flags.context'

export const useFeatureFlags = () => useContext(FeatureFlagsContext)

export const useFeatureFlag = (id) => {
	const flags = useFeatureFlags()
	return flags[id]
}
